import React, { useEffect, useMemo, useState } from "react";
import NumberFormat from "react-number-format";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
} from "../../utils/Currency";
import { useWindowSize } from "../../hook/useWindowSize";
import { getPropByLanguage } from "../../utils/Language";
import { useApp } from "../../contexts";
import { roundNumber } from "../../services/app";

function Item(props) {
  const size = useWindowSize();
  const isMobile = size.width < 1024 ? true : false;
  const {
    T,
    user,
    language,
    convertToLocalCurrency,
    formatLocalCurrency,
    getCurrency,
  } = useApp();
  const [price, setPrice] = useState(0);
  const { itemData, handleClick, isHome } = props;

  const handleParentClick = (id) => {
    if (typeof handleClick == 'function') {
      handleClick()
    }
  };

  const itemUrl = useMemo(() => {
    if (itemData.cloudinaryInfo) {
      return itemData.itemUrl.replace("/f_png/", "/f_png/w_400,c_crop/");
    }
    return itemData.img;
  }, [itemData]);

  useEffect(() => {
    if (itemData) {
      setPrice(
        convertToLocalCurrency(itemData.price, itemData.ccy, getCurrency())
      );
    }
  }, [itemData]);

  return (
    <>
      {!isMobile ? (
        <div
          className={`w-auto item-boxs suzu-card cursor-pointer`}
          onClick={() => handleParentClick(itemData?.id)}
        >
          <div className="lg:p-[12px] xls:p-[14px] p-[10px] pb-[14px] lg:pb-[17px] xls:pb-[20px] rounded-[13px] flex items-center justify-center relative">
            <div
              className={`aspect-[140/114] lg:aspect-[246/195] max-h-[246px] overflow-hidden w-full relative rounded-[13px] bg-[#F7F7F7]`}
            >
              <div className="w-full relative h-full">
                <img
                  src={itemUrl}
                  className="object-cover w-full h-full"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="suzu-card-body">
            <div className={`w-full h-full px-[14px] lg:px-[12px] xls:px-[14px] pt-[0] pb-[12px] lg:pb-[10px] xls:pb-[16px]`}>
              <div className="flex items-center justify-between mb-[6px] lg:mb-[8px]">
                <p className="leading-[18px] lg:leading-[22px] text-[14px] xls:text-[18px] text-[#131516] font-[600] line-clamp-2">
                  {itemData?.name}
                </p>
              </div>
              <div className="flex items-end justify-between">
                <NumberFormat
                  className="text-[#000] text-[14px] lg:text-[16px]/[33px] xls:text-[20px]/[40px] font-[600]"
                  value={formatLocalCurrency(roundNumber(price, 2))}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={prefixCcySymbol(true, getCurrency())}
                  suffix={suffixCcySymbol(true, getCurrency())}
                  decimalScale={validateDecimalSeparator(
                    baseCurrencyCode(true, getCurrency())
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      ) : isHome ? (
        <div
          className={`flex justify-start items-start gap-[13px] py-[11px] suzu_item_mb`}
          onClick={() => handleParentClick(itemData?.id)}
        >
          <div className="w-[40px] h-[40px] rounded-[5px] bg-[#F7F7F7]">
            <img
              src={itemUrl}
              className="object-contain  w-full h-full rounded-[5px]"
              alt=""
            />
          </div>
          <div className="flex flex-col items-start justify-start flex-1">
            <p className="leading-[19px] text-[16px] text-[#272729] font-[600] mb-[4px]">
              {itemData?.name}
            </p>
          </div>
          <div className="flex flex-col items-end">
            <NumberFormat
              className="text-[#272729] text-[16px] font-[600] tracking-[0.2px]"
              value={formatLocalCurrency(roundNumber(price, 2))}
              displayType={"text"}
              thousandSeparator={true}
              prefix={prefixCcySymbol(true, getCurrency())}
              suffix={suffixCcySymbol(true, getCurrency())}
              decimalScale={validateDecimalSeparator(
                baseCurrencyCode(true, getCurrency())
              )}
            />
          </div>
        </div>
      ) : (
        <div
          className={`flex justify-start items-start gap-[16px] bg-[#fff] py-[21px] px-[21px] mb-[15px] rounded-[20px]`}
        >
          <div className="w-[90px] rounded-[5px] bg-[#F7F7F7]">
            <img
              src={itemUrl}
              className="object-contain  w-full h-full"
              alt=""
            />
          </div>
          <div className="flex flex-col items-start justify-start flex-1">
            <p className="leading-[18px] text-[12px] text-[#272729] font-[600] mb-[4px]">
              {itemData?.name}
            </p>
            <NumberFormat
              className="text-[#000] text-[14px]/[21px] font-[500]"
              value={formatLocalCurrency(roundNumber(price, 2))}
              displayType={"text"}
              thousandSeparator={true}
              prefix={prefixCcySymbol(true, getCurrency())}
              suffix={suffixCcySymbol(true, getCurrency())}
              decimalScale={validateDecimalSeparator(
                baseCurrencyCode(true, getCurrency())
              )}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default Item;
